module.exports = __webpack_public_path__ + "booking-fav-icon.png?46b13e9c8b7be7c03591ebaad21aedc2";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/booking-fav-icon.png
// module id = 488
// module chunks = 0